import React from 'react';
import './Disclaimer.css';

const Disclaimer: React.FC = () => (
  <section className="disclaimer">
    <h2 className="disclaimer-title">Disclaimer</h2>
    <p>
      The information provided by the Lext Foundation is for educational and informational purposes only.
      It is not legal advice, does not create an attorney-client relationship, and should not be relied upon as
      a substitute for advice from a qualified immigration attorney or accredited representative.
    </p>
    <p>
      Immigration law and procedures before the Executive Office for Immigration Review (EOIR) and in asylum matters
      are complex and depend on the specific facts of each case. The guidance generated by this system is general in
      nature and may not apply to your situation.
    </p>
    <p>
      For advice about your individual circumstances, please consult a licensed immigration attorney or a Department of
      Justice–accredited representative.
    </p>
    <p>
      Western Illinois Dreamers makes no warranties or representations regarding the accuracy, completeness, or
      timeliness of the information provided through this tool and assumes no liability for actions taken in reliance on it.
    </p>
  </section>
);

export default Disclaimer;

